/**
 * @file 通用 container
 * @author chris<wfsr@foxmail.com>
 */

import React, {ComponentClass} from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter as Router} from 'react-router-dom';
import smartRem from 'smart-rem';
import * as Sentry from '@sentry/react';
import {Integrations} from '@sentry/tracing';
import App from './App';
import store from './store';

import './index.less';


// 设计稿的整个尺寸宽度
const ARGUMENTS = 750;

smartRem(ARGUMENTS);

process.env.ENV_TYPE === 'www' && Sentry.init({
    dsn: 'https://0a88dcd53a454f5099d72744b1c4f0ed@sentry.baijia.com/914',
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});

const render = (Component: ComponentClass) => {
    ReactDOM.render(
        <Provider store={store}>
            <Router>
                <Component />
            </Router>
        </Provider>,
        document.getElementById('app')
    );

    return render;
};

render(App);
